import type { FeatureEvents, ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

export const rovoTrendsScreen = 'rovoTrendsScreen';

interface RovoTrendsScreenEventAttributes {
  currentTab: 'adoption' | 'agents' | 'impact';
  initialLoad: boolean;
}

interface TimeRangeSelectedAttributes {
  selectedTimeRange: 'week' | 'month' | 'quarter' | 'year';
}

interface RovoUsageOverTimeFeatureGroupSelectedAttributes {
  selectedFeatureGroup: string;
}

interface AgentUsageOverTimeAppSelectedAttributes {
  selectedApp: string;
}

type ScreenKeys = 'rovoTrendsScreenEvent';
type UiKeys =
  | 'rovoTrendsTimeRangeSelected'
  | 'rovoTrendsHowTheseInsightsAreCalculatedClicked'
  | 'rovoTrendsDataExportStarted'
  | 'rovoTrendsDataExportConfirmed'
  | 'rovoTrendsDataExportCanceled'
  | 'rovoTrendsUsageOverTimeFeatureGroupSelected'
  | 'rovoTrendsAgentUsageOverTimeAppSelected';

export const rovoTrendsEvents: FeatureEvents<ScreenKeys, UiKeys, string, string> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/3808073480/AdminHub+Analytics+Rovo+Trends+Analytics+event',
  screen: {
    rovoTrendsScreenEvent: (attributes: RovoTrendsScreenEventAttributes): ScreenEvent => ({
      data: {
        name: rovoTrendsScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96014',
    }),
  },
  ui: {
    rovoTrendsTimeRangeSelected: (attributes: TimeRangeSelectedAttributes): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'rovoTrendsTimeRangeSelector',
        source: rovoTrendsScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96017',
    }),
    rovoTrendsHowTheseInsightsAreCalculatedClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'rovoTrendsHowTheseInsightsAreCalculatedLink',
        source: rovoTrendsScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96018',
    }),
    rovoTrendsDataExportStarted: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'rovoTrendsDataExportHeaderButton',
        source: rovoTrendsScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96019',
    }),
    rovoTrendsDataExportConfirmed: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'rovoTrendsDataExportConfirmButton',
        source: rovoTrendsScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96022',
    }),
    rovoTrendsDataExportCanceled: (): UIEvent => ({
      data: {
        action: Action.Cancelled,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'rovoTrendsDataExportCancelButton',
        source: rovoTrendsScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96023',
    }),
    rovoTrendsUsageOverTimeFeatureGroupSelected: (attributes: RovoUsageOverTimeFeatureGroupSelectedAttributes): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'rovoTrendsFeatureGroupSelector',
        source: rovoTrendsScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96024',
    }),
    rovoTrendsAgentUsageOverTimeAppSelected: (attributes: AgentUsageOverTimeAppSelectedAttributes): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'rovoTrendsAppSelector',
        source: rovoTrendsScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/96025',
    }),
  },
  track: {},
  operational: {},
};
